import { ImageResource } from '@shared/models/image-resource.model';
import dayjs, { Dayjs } from 'dayjs';
import {
  DevelopmentApi,
  DevelopmentCampaignApi,
  DevelopmentDigitalBookFileApi,
  DevelopmentVideoApi,
  DevelopmentVirtualTourApi,
} from './development-api.model';
import { Flag } from './flag.model';
import { Project } from './project.model';
import { SharePayload } from '@shared/models/share-event.model';

export class DevelopmentVirtualTour {
  url: string;

  constructor(resource: DevelopmentVirtualTourApi) {
    this.url = resource.url;
  }
}

export class DevelopmentDigitalBookFile {
  url: string;
  description: string;

  constructor(resource: DevelopmentDigitalBookFileApi) {
    this.url = resource.url;
    this.description = resource.description;
  }
}

export class DevelopmentCampaign {
  url: string;
  date: Dayjs;
  title: string;
  sharePayload: SharePayload;

  constructor(resource: DevelopmentCampaignApi, development: DevelopmentApi) {
    this.url = resource.url;
    this.date = dayjs(resource.date);
    this.title = resource.title;
    this.sharePayload = {
      title: 'Materiais de marketing TARRAF',
      code: String(development.id),
      name: 'Materiais de marketing TARRAF',
      url: resource.url,
      text: `Material da campanha ${ development.name }`,
      region: development.region_id ? String(development.region_id) : '',
    };
  }
}

export class DevelopmentVideo {
  url: string;
  date: Dayjs;
  title: string;

  constructor(resource: DevelopmentVideoApi) {
    this.url = resource.url;
    this.date = dayjs(resource.date);
    this.title = resource.title;
  }
}

export class Development {
  id: number;
  star: boolean;
  name: string;
  unitName: string | null;
  call: string;
  regionId: string | null;
  state: string;
  city: string;
  progress: number | null;
  value: number;
  description: string;
  unitsDescription: string | null;
  floorPlan: string | null;
  garage: string | null;
  bedroom: number | null;
  hasSuite: boolean;
  address: string | null;
  googleMapsLink: string | null;
  deliveryDate: Dayjs | null;
  whatsapp: string | null;
  virtualTour: DevelopmentVirtualTour[];
  digitalBook: string | null;
  digitalBookFiles: DevelopmentDigitalBookFile[];
  memorial: string | null;
  memorialFile: string | null;
  priceTable: string | null;
  priceTableFile: string | null;
  campaigns: DevelopmentCampaign[];
  videos: DevelopmentVideo[];
  logo: ImageResource;
  image: ImageResource;
  mapImage: ImageResource | null;
  images: ImageResource[];
  workGallery: ImageResource[];
  planGallery: ImageResource[];
  isFavorite: boolean;
  project: Project;
  flag: Flag;
  // custom properties
  hasGallery: boolean;
  hasSalesMirror: boolean;
  hasPricingTable: boolean;
  hasDigitalBook: boolean;
  hasDescriptiveMemorial: boolean;
  hasVirtualTour: boolean;
  hasMarketingMaterials: boolean;

  constructor(resource: DevelopmentApi) {

    this.id = resource.id;
    this.star = resource.star;
    this.name = resource.name;
    this.unitName = resource.unit_name;
    this.call = resource.call;
    this.regionId = resource.region_id ? String(resource.region_id) : null;
    this.state = resource.state;
    this.city = resource.city;
    this.progress = resource.progress;
    this.value = (resource.value) ? resource.value / 100 : 0;
    this.description = resource.description;
    this.unitsDescription = resource.units_description;
    this.floorPlan = resource.floor_plan;
    this.garage = resource.garage;
    this.bedroom = resource.bedroom;
    this.hasSuite = resource.has_suite;
    this.address = resource.address;
    this.googleMapsLink = resource.google_maps_link;
    this.deliveryDate = resource.delivery_date
                        ? dayjs(resource.delivery_date)
                        : null;
    this.whatsapp = resource.whatsapp;
    this.virtualTour = resource.virtual_tour.map((item) =>
        new DevelopmentVirtualTour(item));
    this.digitalBook = resource.digital_book;
    this.digitalBookFiles = resource.digital_book_files.map((item) =>
        new DevelopmentDigitalBookFile(item));
    this.memorial = resource.memorial;
    this.memorialFile = resource.memorial_file;
    this.priceTable = resource.price_table;
    this.priceTableFile = resource.price_table_file;
    this.campaigns = resource.campaigns.map((item) =>
        new DevelopmentCampaign(item, resource));
    this.videos = resource.videos.map((item) => new DevelopmentVideo(item));
    this.logo = new ImageResource(resource.logo);
    this.image = new ImageResource(resource.image);
    this.mapImage = resource.map_image;
    this.images = resource.images;
    this.workGallery = resource.work_gallery;
    this.planGallery = resource.plan_gallery;
    this.isFavorite = resource.is_favorite;
    this.project = new Project(resource.project);
    this.flag = new Flag(resource.flag);
    this.hasGallery = !!this.videos.length
                      || !!this.images.length
                      || !!this.workGallery.length
                      || !!this.planGallery.length;
    this.hasSalesMirror = !!this.unitName;
    this.hasPricingTable = !!this.priceTable
                           || !!this.priceTableFile;
    this.hasDigitalBook = !!this.digitalBook
                          || !!this.digitalBookFiles.length;
    this.hasDescriptiveMemorial = !!this.memorial
                                  || !!this.memorialFile;
    this.hasVirtualTour = !!this.virtualTour.length;
    this.hasMarketingMaterials = !!this.campaigns.length;
  }
}
